import {Project} from './project';
import {PageResponse} from '../pageResponse';
import {PageRequest} from '../pageRequest';

export class Webhook {
    id?: string;
    path: string;
    protocol: string;
    method: string;
    body?: string;
    project: Project;
    webhookHeaders?: WebhookHeader[];
    webhookParameters?: WebhookParameter[];
    creationDate: string;
    updateDate?: string;
}

export class WebhookHeader {
    id: string;
    key: string;
    value: string;
    creationDate: string;
    updateDate?: string;
}

export class WebhookParameter {
    id: string;
    key: string;
    value: string;
    creationDate: string;
    updateDate?: string;
}

export class WebhookTestResponse {
    statusCode?: number;
    body?: string;
    message?: String;
}

export class CreateUpdateWebhookRequest {
    constructor(public path: string,
                public protocol: string,
                public method: string,
                public body: string,
                public webhookHeaders: WebhookHeader[],
                public webhookParameters: WebhookParameter[]) {}
}

export class WebhookResponse extends PageResponse {
    content: Webhook[];
}

export class WebhookRequest extends PageRequest {
    projectId: string;
}

export class WebhookMacro {
    macroName: string;
    macroValue: string;
}
